import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';

Vue.config.productionTip = false
import 'swiper/swiper.scss'

import '@/style/iconfont.css'

import api from '@/api';
import axios from 'axios';
import BaiduMap from 'vue-baidu-map'
import i18n from './i18n'
Vue.use(ElementUI);
Vue.use(api);
Vue.use(BaiduMap, {
  ak: 'iItrfVQKT5urUdfSGmSEtw0aCVAj98iw'
})
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
